var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"display-2 text-center"},[_c('costum-card',[_c('v-row',[_c('v-col',[_vm._v(" Siden du prøver at tilgå findes ikke. ")])],1),_c('v-row',[_c('v-col',[_c('v-btn',{attrs:{"color":"primary","tile":"","outlined":"","x-large":"","to":"/"}},[_vm._v(" Forside ")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }